<template>
	<div class="" style="background: #f1f1f1;">
		<!--头部-->
		<Header @toggleLang="toggleLang"></Header>
		<div class="layout m-newList">
			<div class="list_count no-padding-top">
				<div class="wow bounceInUp animated">
					<img class="list_img" :src="zidiyiData.zjbanner.files" />
				</div>

				<div class="list_info">
					<!-- 列表 -->

					<div class="info_tit">
						<div class="tit_left">
							<span>班级信息</span>
							<el-divider direction="vertical"></el-divider>
							<span>CLASS INFORMATION</span>
						</div>
					</div>

					<div class="news-list other-list">
						<div class="cont  " v-for="(item,i) in banjiList" @click="go_student(item.id)">
							<img class="pointer" :src="item.image" />
							<div class="info" :style="i<4?'':'margin-left:0px'">
								<div class="tit line-1 ">{{item.name}}
								</div>

							</div>
						</div>
					</div>

					<!-- 分页 -->
					<div class="fenye">
						<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="currentPage4" background :page-size="per_page"
							layout="total, prev, pager, next, jumper" :total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '@/components/Header'
	import Footer from '@/components/Footer'
	import {
		banji_list,
		archives_list
	} from "@/api/api"

	import {
		WOW
	} from 'wowjs'
	export default {
		components: {
			Header,
			Footer
		},
		name: 'list',
		data() {
			return {
				zidiyiData: {
					zjbanner: {
						files: ''
					},
				},
				index: 0,
				banjiList: [],
				currentPage4: 1,
				parent_id: 10,
				id: '',
				list: [], //
				jx_index: 29,
				per_page: 12,
				page: 1,
				arcList: [], //内容列表
				content: {}, //内容详情
				total: 0,
				company_id: 1, //公司ID
				banner: '',
				lang: localStorage.getItem('lang') || 'CN',
			}
		},
		created() {
			this.getChannelList()
			this.getBanner();
			this.addLocatPath()

			this.parent_id = this.$route.query.parent_id

			this.getZidiyiData() //自定义图片

			this.id = this.$route.query.id
			this.jx_index = this.$route.query.id
			if (this.$route.query.index) {
				this.index = this.$route.query.index
			}

			var wow = new WOW({
				boxClass: 'wow',
				animateClass: 'animated',
				offset: 0,
				mobile: true,
				live: true
			});
			wow.init();
		},
		mounted() {

			this.getBanJi()
		},
		methods: {
			toggleLang(str) {
				localStorage.setItem('lang', str)
				this.lang = str
			},

			addLocatPath() {
				let data = {
					directions: '新闻中心',
					path: window.location.href
				}

				this.$axios.get("/api/jx/add_pv", {
					params: data
				}).then((res) => {}).catch(err => {});
			},
			getBanner() {
				let data = {
					company_id: this.company_id,
					tag: '新闻中心'
				}
				this.$axios.get("/api/jx/get_banner", {
					params: data
				}).then((res) => {


					if (res.code == 1) {
						this.banner = res.data.data

					}
				}).catch(err => {});
			},
			go_student(id) {
				this.$router.push({
					path: `student`,
					query: {
						id: id
					}
				})
			},
			// 获取自定义图片
			getZidiyiData() {
				let data = {
					channel_id: 47,
					per_page: this.per_page,
					page: this.page
				}
				this.$axios.get("/api/jx/get_file_all", {
					params: data
				}).then((res) => {
					this.zidiyiData = res.data.data

				}).catch(err => {});
			},
			getChannelList() {
				let data = {
					parent_id: this.parent_id
				}
				this.$axios.get("/api/jx/channel_list", {
					params: data
				}).then((res) => {

					if (res.code == 1) {
						this.list = res.data.data
						console.log(this.list);
					}
				}).catch(err => {});
			},
			filtersText(val) {
				if (val != null && val != '') {
					let reg = /[\u4e00-\u9fa5]/g;
					let names = val.match(reg);
					val = names ? names.join('') : '';
					return val;
				} else return '';
			},
			getBanJi(val) {
				let data = {
					page: val,
					per_page: 12
				}
				banji_list(data).then((res) => {
					if (res.code == 1) {
						this.banjiList = res.data.data
					}
					this.total = res.data.total
				}).catch(err => {});
			},

			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			handleCurrentChange(val) {
				this.page = val
				this.getBanJi(this.page)
			},


			go(id) {
				this.$router.push({
					path: `new_detail?id=${id}`
				})
			},
			go_open(url) {
				if (url) {
					window.open(url, "_blank");
				}
			},

		}
	}
</script>

<style lang="scss" scoped>
	.css3 {
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
	}

	a {
		color: #42b983;
	}

	.col-xs-12,
	.col-lg-3,
	.col-lg-9 {
		padding: 0 !important;
	}

	.m-newList {
		background: #fff;

		.list_count {
			padding: 30px;
		}

		.list_info {
			margin: 50px auto;
			max-width: 1400px;

			.list_img {
				width: 100%;
			}

		}

		.info_tit {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 20px;

			.active {
				border: 2px solid #006170;
				box-shadow: 5px 7px 10px #cddadc;
				color: #000;
			}

			.tit_left {
				span:first-child {
					font-size: 30px;
					color: #000;
					font-weight: bold;
				}

				span:last-child {
					font-size: 14px;
					color: #999;
				}

			}

			.tit_right {
				display: flex;

				span {
					height: 50px;
					line-height: 50px;
					padding: 0 15px;
					text-align: center;
					color: #999;
					font-size: 14px;
					display: block;
					border: 1px solid #eee;
					margin-left: 20px;
				}

			}
		}

		.hover_span {
			cursor: pointer;
		}


	}


	.m-newList .fenye {
		margin-top: 50px;
		text-align: center;
	}

	.m-newList .el-pagination.is-background .el-pager li:not(.disabled).active {
		background-color: #006170;
	}

	.news-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		overflow: hidden;

		.cont {
			margin: 0 40px 40px 0;

			.info_up {
				background: #f3f3f3;
				padding: 40px;
				width: 320px;
				height: 412px;

				.title {
					line-height: 40px;
					height: 40px;
					text-align: center;
					overflow: hidden;
					cursor: pointer;
				}

				.pointer {
					width: 240px;
					height: 332px;
				}
			}
		}

	}

	/*其他列表数据*/
	.other-list .cont {
		width: 327px;
		float: left;
		margin: 0 0 30px 30px;
		overflow: hidden;
	}

	.other-list .cont:nth-child(4n+1) {
		margin-left: 0;
	}


	.other-list .cont img {
		width: 340px;
		height: 340px;
		object-fit: cover;
	}


	.other-list .info {
		margin: 10px 0 0 0px;
		padding: 0 10px;
		overflow: hidden;
	}


	.other-list .tit {
		font-size: 18px;
		color: #000000;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		margin-bottom: 10px;
	}
		.other-list .cont:hover{
			background-color: #f0f4f5;
		}
	.other-list .cont img {
		width: 100%;
		height: auto;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;}

	.other-list .cont:hover img {
		width: 327px;
		transition: all 0.3s ease 0s;
		-webkit-transition: all 0.3s ease 0s;
		-moz-transition: all 0.3s ease 0s;
		-o-transition: all 0.3s ease 0s;
		/*放大 */
		transform:scale(.95);
		-webkit-transform:scale(.95);
		-moz-transform:scale(.95);
		-o-transform:scale(.95);
		-ms-transform:scale(.95);
	}

	.other-list .cont:hover .tit {
		color: #006170;
		cursor: pointer;
	}




	@media screen and (max-width: 1400px) {
		.m-newList .list_info {
			width: 100%;
		}
	}
</style>
